import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { PageHeader } from "../../components/StaffLayout";
import { Tooth } from "@phosphor-icons/react";

export default function Treatments() {
  const [items, setItems] = useState([]);
  const [patients, setPatients] = useState({});

  useEffect(() => {
    Promise.all([api.get("/treatments"), api.get("/patients")]).then(([t, p]) => {
      setItems(t.data);
      const m = {};
      p.data.forEach((pt) => (m[pt.id] = pt));
      setPatients(m);
    });
  }, []);

  return (
    <div data-testid="treatments-page">
      <PageHeader title="Treatment Records" subtitle={`${items.length} treatment${items.length===1?"":"s"} across all patients`} />
      <div className="px-6 sm:px-10 py-8">
        <div className="bg-white border border-zinc-200 rounded-sm divide-y divide-zinc-100">
          {items.length === 0 && (
            <div className="p-10 text-center text-sm text-zinc-500">No treatment records yet. Open any patient to add their first treatment.</div>
          )}
          {items.map((t) => {
            const p = patients[t.patient_id];
            return (
              <div key={t.id} className="px-5 py-4 flex items-start gap-3">
                <Tooth size={22} weight="duotone" color="#E60000" />
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-zinc-900">{t.title}</div>
                  <div className="text-xs text-zinc-500">
                    {t.performed_at?.slice(0, 10)} {t.doctor && `· ${t.doctor}`} {t.cost ? `· ₹${t.cost}` : ""}
                  </div>
                  {t.description && <div className="text-sm text-zinc-700 mt-1">{t.description}</div>}
                </div>
                {p && (
                  <Link to={`/staff/patients/${p.id}`} className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-700 hover:text-[#E60000]">
                    {p.name} ›
                  </Link>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
